import { createContext, useCallback, useContext, useRef, type ReactNode } from "react";

type Registry = {
  register: (fn: () => void) => () => void;
  trigger: () => void;
};

const SessionResetContext = createContext<Registry | null>(null);

export function SessionResetProvider({ children }: { children: ReactNode }) {
  const resettersRef = useRef<(() => void)[]>([]);

  const register = useCallback((fn: () => void) => {
    resettersRef.current.push(fn);
    return () => {
      resettersRef.current = resettersRef.current.filter((f) => f !== fn);
    };
  }, []);

  const trigger = useCallback(() => {
    const list = resettersRef.current;
    for (let i = list.length - 1; i >= 0; i--) {
      list[i]();
    }
  }, []);

  return (
    <SessionResetContext.Provider value={{ register, trigger }}>{children}</SessionResetContext.Provider>
  );
}

export function useSessionResetRegistry(): Registry {
  const ctx = useContext(SessionResetContext);
  if (!ctx) {
    throw new Error("useSessionResetRegistry outside SessionResetProvider");
  }
  return ctx;
}
